export default __webpack_public_path__ + "static/media/tkp.06b92af7.png";